import React from "react";
import { Link } from "react-router-dom";
import { Row } from "reactstrap";
import ButtonComp from "./ButtonComp";

function SubHeader(props) {
  const { title, icon, btnTitle, linkTo } = props;
  return (
    <Row className="my-3">
      <div className="col col-xs-6 col-lg-6 col-md-4 col-sm-5 mr-auto heading">
        {title}
      </div>
      <div className="col-xs-6 m-3 m-md-0 mt-lg-0 mt-md-0 px-3">
        {linkTo ? (
          <Link to={linkTo}>
            {icon ? (
              <ButtonComp title={btnTitle} icon={icon} />
            ) : (
              <ButtonComp title={btnTitle} />
            )}
          </Link>
        ) : null}
      </div>
    </Row>
  );
}

export default SubHeader;
